
import React from 'react';
import './style.scss'
import PropTypes from 'prop-types';

import DateFormatter from 'common/utils/DateFormatter';
import cx from 'classnames';
import {
   MediaComingSoon,
   MediaCardTitle,
   MediaContentButtonOptions,
   MediaTopLables,
} from './modules'
import Link from 'common/components/modules/link';

const MediaCard = ({
   media = {},
   type,
   isLoading,
   cardSize,
   isAgeVerificationRequired,
   contentCardSettings,
   href,
   isNextApp,
}) => {
   const showComingSoon = !!media.is_future_publish_enabled;
   const getPoster = () => {
      if(media?.full_src?.[0]) {
         return media?.full_src?.[0];
      }
      if(media?.image_full_src) {
         const images = [...JSON.parse(media?.image_full_src)]

         return images?.[0];
      }
      if(media?.full_thumbnail) {
         return media?.full_thumbnail;
      }
      return media.poster_src || media.cover_photo
   }

   return (
      <div
         className={ cx(
            {
               'relative flex flex-col h-auto gap-1 mms-media-card': true,
               'mms-media-small-card-size': cardSize === 's',
               'mms-media-medium-card-size': cardSize === 'm',
               'mms-media-large-card-size': cardSize === 'l',
            }
         ) }
      >
         <Link href={ href } isNextApp={ isNextApp } prefetch className='flex flex-col gap-1'>
            <div className='relative w-full overflow-hidden rounded-lg shadow-lg aspect-video '>
               {
                  !isLoading && (
                     <>
                        <MediaTopLables
                           media={ media }
                           contentCardSettings={ contentCardSettings }
                           type={ type }
                        />

                        {
                           showComingSoon && ['video', 'photoset'].includes(type) && (
                              <MediaComingSoon
                                 date={ DateFormatter.getDateLeft(media.publish_date, false, 'In a few minutes') }
                              />
                           )
                        }


                        <img src={ getPoster() } alt='poster' className='absolute inset-0 w-full h-full object-contain object-center z-[9]' />

                        <div
                           className='absolute w-full h-full z-[8] bg-no-repeat bg-cover inset-0'
                           style={ {
                              filter: `blur(8px)`,
                              backgroundImage: `url(${ getPoster() })`,
                           } }
                        />


                        <MediaContentButtonOptions
                           data={ media }
                           isAuthUser={ true }
                           contentCardSettings={ contentCardSettings }
                        />
                     </>
                  )
               }
               {
                  isLoading && (
                     <div className='absolute inset-0 w-full h-full loading-card' />
                  )
               }
            </div>
            <MediaCardTitle
               media={ media }
               isAgeVerificationRequired={ isAgeVerificationRequired }
               isLoading={ isLoading }
               contentCardSettings={ contentCardSettings }
               type={ type }
            />
         </Link>
      </div>
   );
}

MediaCard.propTypes = {
   media: PropTypes.object,
   contentCardSettings: PropTypes.object,
   isAgeVerificationRequired: PropTypes.bool,
   isLoading: PropTypes.bool,
   type: PropTypes.string, //'video', 'photoset'
   cardSize: PropTypes.string,
   isNextApp: PropTypes.bool,
   href: PropTypes.string,
};

MediaCard.defaultProps = {
}
export default MediaCard;


